module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAABYklEQVR42q2U73HCMAzFn7kOkA1IJygb1Bs0G5AN2k5ANoBOwDEBdILQCWCDsEGywa9f5KtITeiH6i5nWX+eY0tPUkaAAqiBPdDxIydgC5T6iwDRAFoD2BhIbfaTrdOgwMoCo+lbs7dmK4He1sZiyxxQ7Z0jvQWi6Q2wcXoHFB6oHCVXQOv8HqwAeufbAGtJmpmtknQMIVxsHyV95p4ihDBIGoCFmRpJNVAksFdJHy7nSdJ5ok5fkhYOfCepntl9ixCCTy4ldRNgF4tJcpYUH9IJQOOchaR3YHDgy/Rukp5HOXNJ85mkQf8jw6/quLaY56rpWqJx+wo4zFx14tUp0uPEX4wL9CLpmKq5k7TMVeuGlFYEWW9GSQdP7D71jrHhVtOWQOd860Q7je7dWXACz9Fp7Ti7muJn4lpl+j5D9A5YGGh3b3JUbtRgp7fAm9l7+/ZXBL8z19Jw7N1w7IzYMZfzDSro71vBYYiAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/globe-icon.png
// module id = 623
// module chunks = 0 1 2 3 4